module.exports = __webpack_public_path__ + "img/logo-sml.87584827.png";